<div class="flex-row full align-start position-relative content-between height-100-pr">
  <button type="button" class="btn color-secondary close-modal" (click)="close(false)"><img
      src="assets/new-assets/icons/icon-close-black.svg" alt="Close" class="height-15-px width-15-px"></button>
  <div class="flex-row align-center height-100-pr">
    <div class=" width-75-pr align-center mr-5 bg-secondary height-100-pr flex-row">
      <img src="assets/new-assets/illustrations/mf-one-more-setp.svg" alt="One more step" class="flex ml-65">
    </div>
    <div class="p-21">
      <h1 mat-dialog-title class="fs-25 ml-25 fw-7">You’re almost there, buddy</h1>
      <div mat-dialog-content class="fs-14 fw-6 ls-2 mr-5 ml-25 mt-20">One more step to ensure your Mutual Fund
        Checklist and you are good to go.</div>
      <div mat-dialog-actions class="column mt-40">
        <button type="button" class="btn btn-primary width-100-pr" (click)="gotoMutualfundProfile()"> Okay, Let’s
          proceed</button>
      </div>
    </div>
  </div>
</div>